import { Button } from '@nexelem/components';
import { useFormContext } from 'react-hook-form';
import { useTableTranslation } from '../translations';
import { selectDefaultView, useSaveViewStore } from '../saveViewFeature';
import { useTableName } from '../utils';
import { Decoder } from './Decoder';
import { useCallback } from 'react';
import { useIsDirtyView } from './useIsDirtyView';

type ResetFiltersButtonProps = {
  className?: string;
  variant?: 'text' | 'outlined' | 'contained';
};

export const ResetFiltersButton = ({ className, variant = 'text' }: ResetFiltersButtonProps) => {
  const { t } = useTableTranslation();
  const tableName = useTableName();
  const defaultView = useSaveViewStore(selectDefaultView(tableName));
  const isDirtyView = useIsDirtyView();

  const { reset } = useFormContext();

  const resetToDefaultView = useCallback(async () => {
    if (defaultView) {
      const defaultViewData = await Decoder.decode(defaultView?.data);
      reset(defaultViewData);
    } else {
      reset();
    }
  }, [reset, defaultView]);

  if (!isDirtyView) {
    return null;
  }

  return (
    <Button className={className} variant={variant} onClick={resetToDefaultView}>
      {t('reset')}
    </Button>
  );
};
